import moment from "moment";

export const DATE_FORMAT_CODE = "YYYY-MM-DD";
export const TIME_FORMAT_CODE = "HH:mm";

export const DATE_FORMAT_READABLE = "D MMMM";
export const DAY_FORMAT_READABLE = "dddd";
export const TIME_FORMAT_READABLE = "h:mma";

export function formatDateReadable(date: string): string {
  return moment(date, DATE_FORMAT_CODE).format(DATE_FORMAT_READABLE);
}

export function formatTimeReadable(time: string): string {
  return moment(time, TIME_FORMAT_CODE).format(TIME_FORMAT_READABLE);
}

export function dateToDay(date: string): string {
  return moment(date, DATE_FORMAT_CODE).format(DAY_FORMAT_READABLE);
}
